export default {
  AQUA_BLUE: "#1b4980",
  DUSK_BLUE: "#102943",
  MIDNIGHT_BLUE: "#0D1B2A",
  SALMON_RED: "#FF6C6C",
  SNOW_GREY: "#EEEEEE",
  TRANSPARENT: "transparent",
  WHITE: "#FFFFFF",
};
